module.exports = __webpack_public_path__ + "static/img/puzzle-80px.9c3cd7cc.png";